import { render, staticRenderFns } from "./CategoryStatus.vue?vue&type=template&id=24d17f3d&scoped=true"
import script from "./CategoryStatus.vue?vue&type=script&lang=js"
export * from "./CategoryStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-co_9d3e8444ee7ad6f099877d142dfca7ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d17f3d",
  null
  
)

export default component.exports